import { render } from "./EditOrder.vue?vue&type=template&id=0456afeb&scoped=true"
import script from "./EditOrder.vue?vue&type=script&lang=js"
export * from "./EditOrder.vue?vue&type=script&lang=js"

import "./EditOrder.vue?vue&type=style&index=0&id=0456afeb&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0456afeb"]])

export default __exports__